import axios, { AxiosError } from "axios";
const ConsignmentReusablePackagingResource = {
    get(consignmentId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/consignments/${consignmentId}/reusable-packagings`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    update(consignmentId, consignmentReusablePackagingId, request, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/consignments/${consignmentId}/reusable-packagings/${consignmentReusablePackagingId}`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    create(consignmentId, request, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/consignments/${consignmentId}/reusable-packagings`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    delete(consignmentId, consignmentReusablePackagingId, resultFunc, errorFunc, finallyFunc) {
        axios.delete(`/admin/v1/consignments/${consignmentId}/reusable-packagings/${consignmentReusablePackagingId}`)
            .then(response => resultFunc())
            .catch(errorFunc)
            .finally(finallyFunc);
    }
};
export default ConsignmentReusablePackagingResource;
